import { openBlock as t, createElementBlock as e, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ l("path", {
  fill: "#0052B4",
  d: "M20 40c11.046 0 20-8.954 20-20a19.9 19.9 0 0 0-2.29-9.297l-17.734 9.32 9.32-17.734A19.911 19.911 0 0 0 20 0C8.954 0 0 8.954 0 20a19.938 19.938 0 0 0 5.858 14.142A19.937 19.937 0 0 0 20 40Z"
}, null, -1), s = /* @__PURE__ */ l("path", {
  fill: "#F0F0F0",
  d: "M37.69 10.725a19.996 19.996 0 0 0-3.571-4.844 19.992 19.992 0 0 0-4.844-3.57L5.835 34.165l31.855-23.44Z"
}, null, -1), a = /* @__PURE__ */ l("path", {
  fill: "#FF9811",
  d: "M5.835 34.166 37.69 10.725a19.996 19.996 0 0 0-3.571-4.844L5.835 34.166Z"
}, null, -1), c = /* @__PURE__ */ l("path", {
  fill: "#F0F0F0",
  d: "m17.368 11.728-2.442 1.15 1.3 2.365-2.652-.508-.336 2.68-1.848-1.97-1.847 1.97-.336-2.68-2.653.508 1.301-2.366-2.442-1.149 2.442-1.149-1.3-2.365 2.652.507.336-2.68 1.847 1.971 1.848-1.97.336 2.68 2.652-.508-1.3 2.365 2.442 1.15Z"
}, null, -1), d = [
  n,
  s,
  a,
  c
];
function i(_, h) {
  return t(), e("svg", o, [...d]);
}
const f = { render: i };
export {
  f as default,
  i as render
};
